import React from 'react';
import { motion } from 'framer-motion';
export const FinalCTA = () => {
  return <section className="py-12 bg-gold-500 relative overflow-hidden" data-id="element-58">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 pointer-events-none" data-id="element-59"></div>
      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-60">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-legal-900 mb-6" data-id="element-61">
          Dejá de empezar cada reclamo desde cero.
        </h2>
        <p className="text-xl text-legal-800 font-medium mb-10 max-w-2xl mx-auto" data-id="element-62">
          Accedé hoy al Tratado Práctico de Defensa del Consumidor 2026 y
          resolvé reclamos de consumo con mayor rapidez, seguridad y respaldo
          jurídico.
        </p>
        <motion.a href="#oferta" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-block px-10 py-5 bg-legal-900 text-white font-bold rounded-xl text-xl shadow-2xl hover:bg-legal-800 transition-colors" data-id="element-63">
          QUIERO MI TRATADO AHORA
        </motion.a>
      </div>
    </section>;
};